<template>
  <div>
    <div style="width:100%;border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">基本信息</div>
    <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
      <tr>
        <td class="tableLabel">售后单号：</td>
        <td>{{maintainVo.billNo}}</td>
        <td class="tableLabel">出厂编号：</td>
        <td>{{maintainVo.factoryNo}}</td>
        <td class="tableLabel">客户名称：</td>
        <td>{{maintainVo.customerName}}</td>
      </tr>
      <tr>
        <td class="tableLabel">现场名称：</td>
        <td>{{maintainVo.siteName}}</td>
        <td class="tableLabel">现场联系人：</td>
        <td>{{maintainVo.siteContacts}}</td>
        <td class="tableLabel">已过维保期：</td>
        <td>{{maintainVo.isMaintenancePeriod?"是":"否"}}</td>
      </tr>
      <tr>
        <td class="tableLabel">退回单号：</td>
        <td>{{maintainVo.backNo}}</td>
        <td class="tableLabel">退回日期：</td>
        <td colspan="3">{{maintainVo.backTime}}</td>
      </tr>
      <tr>
        <td class="tableLabel">收货人：</td>
        <td>{{maintainVo.consignee}}</td>
        <td class="tableLabel">收货联系方式：</td>
        <td colspan="3">{{maintainVo.consigneeContacts}}</td>
      </tr>
      <tr>
        <td class="tableLabel">收货联系地址：</td>
        <td colspan="5">{{maintainVo.deliveryAddress}}</td>
      </tr>
      <tr>
        <td class="tableLabel">请求发货方式：</td>
        <td>{{maintainVo.deliveryMethod}}</td>
        <td class="tableLabel">请求发货日期：</td>
        <td>{{maintainVo.deliveryTime}}</td>
        <td class="tableLabel">运费是否到付：</td>
        <td>{{maintainVo.isFreightCollect?"是":"否"}}</td>
      </tr>
      <tr>
        <td class="tableLabel">备注：</td>
        <td colspan="5">{{maintainVo.note}}</td>
      </tr>
    </table>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">物料信息</div>
      <el-table
          :data="maintainVo.details"
          border>
        <el-table-column prop="materialNo" width="160" align="center" label="物料编号"/>
        <el-table-column prop="materialName" width="200" align="center" label="物料名称"/>
        <el-table-column prop="materialType" width="150" align="center" label="产品分类"/>
        <el-table-column prop="originalProgramNo" width="130" align="center" label="原程序号"/>
        <el-table-column prop="newProgramNo" width="130" align="center" label="新程序号"/>
        <el-table-column prop="serialNumber" width="130" align="center" label="变频器序列号"/>
        <el-table-column prop="quantity" width="100" align="center" label="数量"/>
        <el-table-column prop="unit" width="100" align="center" label="单位"/>
        <el-table-column prop="siteDesc" align="center" label="现场问题描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.siteDesc" disabled type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryType" width="130" align="center" label="发运类型"/>
      </el-table>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">维修附件</div>
      <el-table
          ref="payData1"
          :data="maintainVo.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  export default {
    name:"",
    components:{HandleDetail},
    data() {
      return {
        billId:"",
        billType:"26",
        pkid:"",
        imgUrls: [],
        maintainVo:{
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.pkid = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.pkid = "";
      this.maintainVo={};
    },
    methods:{
      downLoad(row) {
        console.log(row);
        let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      getData() {
        this.$http.get("basic",`maintains/${this.billId}`).then((res)=>{
          console.log(res);
          this.maintainVo = res;
          this.maintainVo.attachments.forEach(row=>{
            if(row.filePath.includes("common")) {
              row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
              this.imgUrls.push(row.imgUrl);
            }else {
              row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
              this.imgUrls.push(row.imgUrl);
            }
          });
        }).catch(()=>{
        });
      },
    },
  };
</script>

<style lang="scss">
  table.ProjectOrderTable {
    font-family: verdana,arial,sans-serif;
    font-size:11px;
    color:#333333;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  table.ProjectOrderTable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    background-color: #f4f7fa;
  }
  table.ProjectOrderTable td {
    padding: 8px;
    border-right: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
  }
  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
</style>
